module.exports = __webpack_public_path__ + "img/zz.baf78b20.png";